import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from '../../utils/auth'

export default (store) => ({
  path: 'customer-purchase',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const CustomerPurchaseAnalyticsContainer = require('./containers/CustomerPurchaseAnalytics').default
      const reducer = require('./modules/customerPurchaseAnalytics').reducer
      let homeReducers = require('../Home/modules/home')
      const {loadStoreOptionsReducer, loadStoreTagOptionsReducer} = require('../SalesAnalytics/modules/salesAnalytics');

      /*  Add the reducer to the store on key 'counter'  */
      const filterValuesReducer = homeReducers.filterValuesReducer
      injectReducer(store, {key: 'customerPurchaseAnalytics', reducer: reducer})

      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})

      injectReducer(store, {key: 'filter', reducer: filterValuesReducer})
      /*  Return getComponent   */
      cb(null, CustomerPurchaseAnalyticsContainer)

      /* Webpack named bundle   */
    }, 'customerPurchaseAnalytics')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CustomerPurchaseAnalytics/index.js